module.exports = __webpack_public_path__ + "cb3ba2bcfeb9fbc26e96ac0f5f78deab.jpg";